import React, { lazy, Suspense, useEffect, useState } from 'react';
import Navbar from './components/Navbar/navbar';
import { Route, useLocation, Switch, Redirect } from 'react-router-dom';
import Home from './components/Home/home';
import Footer from './components/Footer/Footer';
import './App.scss';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { isNil } from 'lodash';
const Team = lazy(() => import('./components/Team/team'));
const Career = lazy(() => import('./components/career/career'));
const ContactUs = lazy(() => import('./components/contactUs/contactUs'));
const UserInfo = lazy(() => import('./components/EarlyAccessUser/userInfo'));
const Thankyou = lazy(() => import('./components/Thanks/Thankyou'));
const Student = lazy(() => import('./components/Student/Student'));
const Teacher = lazy(() => import('./components/Teacher/Teacher'));
const SubmitQuestion = lazy(() => import('./components/SubmitQuestion/SubmitQuestion'));
const Login = lazy(() => import('./components/Login/Login'));
const SignUp = lazy(() => import('./components/SignUp/SignUp'));
const CreateClass = lazy(() => import('./components/CreateClass/CreateClass'));
const CameraCapture = lazy(() => import('./components/UploadImage/UploadImage'));
const Feedback = lazy(() => import('./components/Feedback/Feedback'));
const PageNotFound = lazy(() => import('./components/PageNotFound/PageNotFound'));
const Flyer = lazy(() => import('./components/Flyer/Flyer'));
const TermsandCondition = lazy(() => import('./components/PrivacyPolicy/TermsandCondition'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy/PrivacyPolicy'));
const dashboard = lazy(() => import('./components/dashboard/dashboard'));
const SignUpPlans = lazy(() => import('./components/SignUp/SignUpPlans'));
const RequestDemo = lazy(() => import('./components/Teacher/RequestDemo'));
const ScheduleDemo = lazy(() => import('./components/Teacher/ScheduleDemo'));
const Resources = lazy(() => import('./components/Resources/Resources'));
const MagicLinkVerify = lazy(() => import('./components/MagicLinkVerify/MagicLinkVerify'));
const PilotForms = lazy(() => import('./components/PilotForms/PilotForms'));
const Workplace = lazy(() => import('./components/Workplace/Workplace'));

const PILOT_FORMS_PATH = '/pilotforms';
const WORKPLACE_PATH = '/workplace';

function App() {
  const location = useLocation();
  const pagePath = location.pathname.toLowerCase();
  const [isLogRocketInitialize, setIsLogRocketInitialize] = useState(false);
  const isEmbeddedView = new URLSearchParams(location.search).get('embed') === '1';
  const isFeedbackPage = pagePath.includes('/feedback');
  // Workplace (employee leave/WFH tool) has its own header and no marketing footer.
  const isWorkplacePage = pagePath.startsWith(WORKPLACE_PATH);

  useEffect(() => {
    const initializeLogRocket = async () => {
      if (isLogRocketInitialize) return;

      const [{ default: LogRocket }, { ClientJS }] = await Promise.all([
        import('logrocket'),
        import('clientjs'),
      ]);
      const client = new ClientJS();
      const fingerprint = client.getFingerprint();

      if (!isNil(LogRocket)) {
        LogRocket.identify(fingerprint.toString(), {
          name: fingerprint,
          email: fingerprint + '@aiplato.ai',
        });
        LogRocket.init('zdohul/aiplato');
        setIsLogRocketInitialize(true);
      }
    };

    initializeLogRocket();
  }, [location]);
  return (

    <div className={`main-container${pagePath.includes(PILOT_FORMS_PATH) ? ' main-container--pilotForms' : ''}`}>

      <ToastContainer />
      {!isEmbeddedView && !pagePath.includes('/question') && !pagePath.includes('/termsandcondition') && !pagePath.includes('/privacypolicy') && !isFeedbackPage && !isWorkplacePage &&
        <Navbar />
      }
      <div className={`app-content${pagePath.includes(PILOT_FORMS_PATH) ? ' app-content--pilotForms' : ''}`}>
      <Suspense fallback={null}>
        <Switch>
          <Route path="/" exact component={Home} />
          {/* <Route path="/home" exact component={Home} /> */}
          <Route path="/earlyaccesspriorityinfo/:earlyaccessid?" exact component={UserInfo} />
          <Route path="/student" exact component={Student} />
          <Route path="/educator" exact component={Teacher} />
          <Route path="/team" exact component={Team} />
          <Route path="/careers" exact component={Career} />
          <Route path="/contact" exact component={ContactUs} />
          <Route path="/thankyou" exact component={Thankyou} />
          <Route path="/question" exact component={SubmitQuestion} />
          <Route path="/login" component={Login} />
          {/* <Route path="/signup/:useruniqueid?" component={SignUp} /> */}
          <Route path="/signup/:userplan?/:useruniqueid?" component={SignUp} />
          <Route path="/createclass" component={CreateClass} />
          <Route path="/upload" component={CameraCapture} />
          <Route path="/feedback" component={Feedback} />
          <Route path="/GSVsummitSpecial" component={Flyer} />
          <Route path="/PageNotFound" component={PageNotFound} />
          <Route path="/termsandcondition" exact component={TermsandCondition} />
          <Route path="/privacypolicy" exact component={PrivacyPolicy} />
          <Route path="/ptdashboard" exact component={dashboard} />
          <Route path="/signUpPlans/:useruniqueid?" component={SignUpPlans} />
          <Route path="/requestDemo" exact component={RequestDemo} />
          <Route path="/scheduleDemo" exact component={ScheduleDemo} />
          <Route path="/resources" exact component={Resources} />
          <Route path="/verify-email" exact component={MagicLinkVerify} />
          <Route path="/payment-success" exact component={SignUp} />
          <Route path={PILOT_FORMS_PATH} exact component={PilotForms} />
          <Route path={WORKPLACE_PATH} component={Workplace} />

          <Redirect to="/PageNotFound" ></Redirect>
        </Switch>
      </Suspense>
      </div>

      {(!isEmbeddedView && !pagePath.includes('/question') && !pagePath.includes('/upload') && !pagePath.includes('/termsandcondition') && !pagePath.includes('/privacypolicy') && !pagePath.includes('/feedback') && !pagePath.includes(PILOT_FORMS_PATH) && !isWorkplacePage) &&
        <div className="footer">
          <Footer></Footer>
        </div>
      }


    </div>
  );
}

export default App;
